import { graphql } from '@/generated/gql';

export const NEGOTIATION_CASE_SUPPLIER_INTRODUCTION_MESSAGE_QUERY = graphql(/* GraphQL */ `
  query NegotiationSupplierIntroductionMessage($id: UUID!) {
    tesseract {
      negotiationCase(id: $id) {
        id
        status
        supplierIntroductionMessage {
          text
          language
        }
      }
    }
  }
`);
